// Local image variants: no image-generation service runs in the browser.
const image = (name, width, height, widths, alt) => ({
  src: `/assets/artwork/${name}-${width}.webp`,
  srcSet: widths.map((size) => `/assets/artwork/${name}-${size}.webp ${size}w`).join(", "),
  width,
  height,
  alt,
});

export const ARTWORK = {
  hero: image("hero-emblem-official", 1254, 1254, [480, 800, 1254], "KINGBULLISH emblem: two neon-green bulls, a crowned globe and KB lettering inside a green ring"),
  space: image("site-wallpaper-neon-desktop", 1672, 941, [1280, 1672], ""),
  wallpaperMobile: image("site-wallpaper-neon-mobile", 529, 941, [480, 529], ""),
  nfts: {
    ...image("king-nfts-collection", 1536, 1024, [480, 800, 1536], "KINGBULLISH NFT collection: six distinctive bull characters around the KINGBULLISH banner"),
    unobscured: true,
  },
  portfolios: {
    ...image("smart-portfolios-wallets", 1536, 1024, [480, 800, 1536], "KINGBULLISH SMART WALLETS illustration: AI, Quantum, Semiconductors and Tech wallets in green, blue, purple and gold"),
    unobscured: true,
  },
  app: {
    ...image("kingbullish-app-four-panels", 1536, 1024, [480, 800, 1536], "KINGBULLISH APP concept: Trade Smarter, Invest, Crypto All in One and Finance panels in green, blue, purple and gold; screens are illustrative, not live data"),
    unobscured: true,
  },
  kbAi: {
    ...image("kb-ai-four-panels", 1536, 1024, [480, 800, 1536], "KB AI concept illustration: four panels showing a trading copilot, analytics, asset charts and automation; screens and figures are illustrative, not live data"),
    unobscured: true,
    useNativeRatio: true,
  },
  ai: {
    ...image("ai-portfolio-official", 1254, 1254, [320, 600, 1254], "AI portfolio: emerald circuit brain with a gold crown, KB processor and complete green ring"),
    unobscured: true,
  },
  quantum: {
    ...image("quantum-portfolio-official", 1254, 1254, [320, 600, 1254], "Quantum portfolio: crowned quantum computer with KB symbols and a complete emerald green ring"),
    unobscured: true,
  },
  semiconductors: {
    ...image("semiconductors-portfolio-official", 1254, 1254, [320, 600, 1254], "Semiconductors portfolio: crowned KB microchip on an emerald circuit board with a complete green ring"),
    unobscured: true,
  },
  tech: {
    ...image("tech-portfolio-official", 1254, 1254, [320, 600, 1254], "Tech portfolio: crowned connected globe with KB symbol, Global Tech lettering and a complete emerald ring"),
    unobscured: true,
  },
  energy: {
    ...image("clean-energy-portfolio-official", 1254, 1254, [320, 600, 1254], "Clean Energy portfolio: crowned KB globe with solar panels, wind turbines, hydropower, batteries and a complete green ring"),
    unobscured: true,
  },
  spaceDefense: {
    ...image("space-defense-portfolio-official", 1254, 1254, [320, 600, 1254], "Space and Defense portfolio: crowned KB globe with satellites, rocket, aircraft, lettering and a complete green ring"),
    unobscured: true,
  },
};

export const ARTWORK_SIZES = {
  hero: "(min-width: 1700px) 500px, (min-width: 1480px) 442px, (min-width: 1024px) calc(44.88vw - 223.3px), (min-width: 480px) 405px, calc(92vw - 29.44px)",
  ecosystem: "(min-width: 1700px) 365px, (min-width: 1480px) 335px, (min-width: 1280px) calc((100vw - 140px) / 4), (min-width: 1024px) calc((100vw - 100px) / 2), (min-width: 640px) calc((100vw - 68px) / 2), calc(100vw - 32px)",
  portfolio: "(min-width: 1700px) 200px, (min-width: 1480px) 183px, (min-width: 1280px) calc((100vw - 176px) / 7.15), (min-width: 1024px) calc((100vw - 112px) / 3), (min-width: 640px) calc((100vw - 64px) / 2), calc(100vw - 32px)",
};